import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './PromoNotification.module.css';

const PromoNotification = ({ onDismiss }) => {
  // Only track visibility within current session
  const [isVisible, setIsVisible] = useState(false);
  
  const dismissNotification = () => {
    setIsVisible(false);
    // Call the parent callback if provided
    if (onDismiss) {
      onDismiss();
    }
  };
  
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div 
          className={styles.promoBar}
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -100, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <div className={styles.promoContent}>
            <div className={styles.promoText}>
              🔥 Founders Deal: 50% Off for LIFE for Early Adopters — Limited Time Only!
            </div>
            <button 
              className={styles.dismissButton} 
              onClick={dismissNotification}
              aria-label="Dismiss notification"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PromoNotification; 